// Stable, namespaced class names for the Iconify component — exported so
// consumers (or test selectors) can target the wrapper without depending on
// emotion-generated class strings.
export const iconifyClasses = {
  root: 'iconify__root',
} as const;
